import { useEffect, useState } from 'react';

import 'react-loading-skeleton/dist/skeleton.css';
import PageSettingsApi from '../../../Api/PageSettingsApi';
import SiteApi from '../../../Api/SiteApi/SiteApi';
import { is25LottoKenya, isTemplateBeta, isTemplateDelta } from '../../../utils/template';

import DefaultTemplate from './Templates/DefaultTemplate';
import DeltaTemplate from './Templates/DeltaTemplate';

type Props = Readonly<{
    displaynewsdate?: string;
    timezone?: string;
    appname?: string;
    defaultthumbnailsrc?: string;
    getallnews?: string;
}>;

function News({ displaynewsdate, timezone, appname, defaultthumbnailsrc, getallnews }: Props) {
    const [news, setNews] = useState(
        Array(3).fill({ id: null, image: null, short_text: null, title: null, created_at: null, slug: null })
    );
    const [loading, setLoading] = useState(true);
    const [hiddenComponent, setHiddenComponent] = useState(false);
    const [isNewsImgVisible, setIsNewsImgVisible] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const getAllNews: boolean = getallnews === 'true';

    useEffect(
        function () {
            PageSettingsApi.isImgVisible().then((response) => {
                setIsNewsImgVisible(response.data);
            });
            SiteApi.news(getAllNews, currentPage)
                .then((response) => {
                    if (response.data.length === 0) {
                        setHiddenComponent(true);
                    } else {
                        setNews(response.data);
                        if (response.currentPage && response.lastPage) {
                            setCurrentPage(response.currentPage);
                            setLastPage(response.lastPage);
                        }
                    }

                    setLoading(false);
                })
                .catch(() => {
                    setHiddenComponent(true);
                });
        },
        [currentPage]
    );

    function getContent() {
        if (isTemplateDelta() || isTemplateBeta() || is25LottoKenya()) {
            return DeltaTemplate({
                news,
                loading,
                hiddenComponent,
                displaynewsdate: !!displaynewsdate,
                timezone,
                defaultthumbnailsrc,
                appname,
                getAllNews,
                lastPage,
                currentPage,
                setCurrentPage,
                isNewsImgVisible,
            });
        }

        return DefaultTemplate({
            news,
            loading,
            hiddenComponent,
            displaynewsdate: !!displaynewsdate,
            timezone,
            defaultthumbnailsrc,
            getAllNews,
            lastPage,
            currentPage,
            setCurrentPage,
            isNewsImgVisible,
        });
    }

    return getContent();
}

export default News;
